import React from "react";

import { updateProfile } from "api/Users";
import { CheckMarkIcon } from "components/svg";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "components/ui/Modal";
import FileInput from "components/forms/FileInput";
import BasicButton from "components/forms/BasicButton";
import { useToast } from "components/toast";

export default function LogoUpload({ user, title, afterUpload }: { user: any, title: string, afterUpload?: (e?: any) => void }) {

  const toast = useToast(); 

  const [value, setValue] = React.useState<any>(null);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  async function _onSubmit() {
    if(value){
      setIsSubmitting(true);
      await fetch(value.url, {
        method: "PUT",
        headers: {'Content-Type': value?.file?.type},
        body: value?.file
      }).then(async (res: any) => {
        if(res.ok){ 
          const res = await updateProfile({ update : { data : [{ key : "logo", value : value.location, type : "image"  }] } });
          if(res?.id){ 
            toast.add("Images uploaded","var(--theme-ui-colors-success)");      
            setIsOpen(false);
            if(typeof afterUpload === 'function') afterUpload(res);
          } else{
            toast.add(res?.message ? res.message : "Error uploading images","var(--theme-ui-colors-danger)");
          } 
        }
      }).catch((err) => {
        toast.add("Error uploading images","var(--theme-ui-colors-danger)");
      });  
      setIsSubmitting(false);            
    }    
  }

  return (
    <>
      <BasicButton scheme="secondaryOutline" onClick={() => setIsOpen(!isOpen)}>{title}</BasicButton>
      <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} centered>    
        <ModalHeader toggle={() => setIsOpen(!isOpen)}></ModalHeader>    
        <ModalBody>
          <FileInput                
            directory={`users/${user.id}`}
            onChange={(val: any) => { setValue(val[0])}}  
            refreshValue={isSubmitting}                     
          />
        </ModalBody>
        <ModalFooter>
          <BasicButton
            scheme="secondaryOutline"  
            styles={{margin:"0 10px 0 0"}}               
            type="button" 
            onClick={() => setIsOpen(false)} 
          >Cancel</BasicButton>   
          <BasicButton 
            type="submit" 
            onClick={_onSubmit}
            $submitting={isSubmitting}
            $iconHeight="14px"
            $iconWidth="14px"
            $loadingColor="#fff"
            keepText={true}
          >{!isSubmitting && <CheckMarkIcon fill={"#fff"} />}Upload</BasicButton>
        </ModalFooter>      
      </Modal>
    </>
  );
}